import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import {
  createInventoryCategory,
  updateInventoryCategory,
} from 'redux/modules/inventoryCategories';

import * as validate from 'utils/validate';

import objectDiff from 'utils/objectDiff';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  if (props.ID) {
    if (props.pristine) {
      throw new SubmissionError({
        _error: 'Nothing to submit',
      });
    }
    const diffValues = objectDiff(values, props.initialValues);
    return new Promise((resolve, reject) => {
      dispatch(updateInventoryCategory({
        values: {
          ID: props.ID,
          ...diffValues,
        },
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        throw new SubmissionError({ _error: err.error.indexOf('Unique check fail') !== -1
          ? 'Sorry, but such Inventory Category already exists' : err.error });
      });
  }

  return new Promise((resolve, reject) => {
    dispatch(createInventoryCategory({
      values: {
        ...values,
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError({ _error: err.error.indexOf('Unique check fail') !== -1
        ? 'Sorry, but such Inventory Category already exists' : err.error });
    });
}

const InventoryCategoryCreateEditForm = ({
  handleSubmit,
  className,
  error,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Name"
          name="Name"
          label="Name"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

InventoryCategoryCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryCategoryCreateEditForm.defaultProps = {
  className: '',
  error: null,
};

export default reduxForm({
  form: 'inventoryCategoryCreate',
  onSubmit,
})(withStyles(styles)(InventoryCategoryCreateEditForm));



// WEBPACK FOOTER //
// ./src/components/settings/InventoryCategoryCreateEditDialog/InventoryCategoryCreateEditForm.js